export default "__VITE_ASSET__f740f208__"